import type React from "react";

import type { IconName } from "@similarweb/icons";

import type { ECategoryType, ICategory } from "app/common/services/categoryService.types";

export enum ETabs {
    PRE_DEFINED,
    CUSTOM,
    SHARED,
}

export interface IAutocompleteWebCategoriesProps {
    children?: React.ReactNode;
    selectedValue?: ICategory;
    onClick: (selectedValue: ICategory, query?: string) => void;
    autocompleteProps: any;
    className?: string;
    /**
     * Forces focus on the selected result tab. if no value is provided, then the categories tab will be opened by default
     */
    defaultSelectedTab?: ETabs;
    showCustomCategoryEmptyState?: boolean;
    onCreateCustomCategoryClick?: () => void;
    onClearSearch?: () => void;
    showOnlyCategories?: boolean;
    showOnlyCustom?: boolean;
    categoryModalProps?: {
        categoryType?: ECategoryType | string;
    };
    isPartnerPage?: boolean;
    onCloseCustomCategoriesModal?: VoidFunction;
    customResolveItemIcon?: (item: ICategory, isChild: boolean) => IconName;
    disabledCategories?: ICategory[];
    isCompare?: boolean;
    hasSelectedCategoryWithSegments?: boolean;
}
